<!--
 * @Author: hfxie
 * @Date: 2021-01-01 17:10:10
 * @LastEditors: haifeng_xie haifeng_xie@kingdee.com
 * @LastEditTime: 2024-11-07 09:01:40
 * @Description: 甘特图右侧下方区横道间关系连接线组件
-->

<template>
  <div class="gantt-line" :style="getHeight" v-show="getLinesArr.length > 0">

    <!-- 任务块组合连线 -->
    <div class="task-line-box">
      <template v-for="(item, itemIndex) in getLinesArr">
        <div
          class="task-line-item"
          :key="`${item.s_index}_${item.e_index}_${item.t_w}_${item.t_h}_${item.type}`"
          :style="`
                    width: ${item.t_w}px;
                    height: ${item.t_h}px;
                    left: ${item.s_x}px;
                    top: ${item.s_y}px;
                    ${(item.type === 4)? 'transform:rotate(' + item.e_w + 'deg)': ''}
                  `"
          :class="{
            'act-line': actLine == itemIndex
          }"
          :data-type="item.type"
        >
          <!-- 7字型 -->
          <template v-if="item.type == 5">
            <div
              class="task-line-7-start"
              :class="{
                'task-line-7-left': item.s_type == 'next',
                'task-line-7-right': item.s_type == 'pre',
                'task-line-top': item.direction_Y == 1,
                'task-line-bot': item.direction_Y == -1,
              }"
            >
              <div class="task-line-7-start-show task-line-shadow"></div>
            </div>
            <div
                class="task-line-7-end"
                :class="{
                  'task-line-7-end-left': item.e_type == 'next',
                  'task-line-7-end-right': item.e_type == 'pre',
                  'task-line-7-end-top': item.direction_Y == 1,
                  'task-line-7-end-bot': item.direction_Y == -1,
                }"
            >
              <div class="task-line-7-end-show task-line-shadow"></div>
              <div class="task-line-7-arrow"></div>
            </div>
          </template>

          <!-- Z字型 -->
          <template v-else-if="(item.s_type != item.e_type) && item.type == 2">
            <div
              class="task-line-z-start"
              :class="{
                'task-line-z-left': item.s_type == 'next',
                'task-line-z-right': item.s_type == 'pre',
                'task-line-top': item.direction_Y == 1,
                'task-line-bot': item.direction_Y == -1,
              }"
              :style="`width: ${item.s_w}px;`"
            >
              <div class="task-line-z-start-show task-line-shadow"></div>

              <div
                class="task-line-y-total"
                :class="{
                  'task-line-y-total-left': item.s_type == 'pre',
                  'task-line-y-total-right': item.s_type == 'next',
                  'task-line-top': item.direction_Y == 1,
                  'task-line-bot': item.direction_Y == -1,
                }"
                :style="`height: ${item.t_h}px;`"
              >
                <div class="task-line-y-total-show task-line-shadow"></div>
              </div>
            </div>

            <div
              class="task-line-z-end"
              :class="{
                'task-line-z-end-left': item.e_type == 'next',
                'task-line-z-end-right': item.e_type == 'pre',
                'task-line-top': item.direction_Y == -1,
                'task-line-bot': item.direction_Y == 1,
              }"
              :style="`width: ${item.e_w}px;`"
            >
              <div class="task-line-z-end-show task-line-shadow"></div>
              <div class="task-line-arrow"></div>

            </div>
          </template>

          <!-- ]字型 -->
          <template v-else-if="(item.s_type == item.e_type) && item.type !== 4">
            <div
              class="task-line-x-start"
              :class="{
                'task-line-x-show-left': item.s_type == 'pre',
                'task-line-x-show-right': item.s_type == 'next',
                'task-line-top': item.direction_Y == 1,
                'task-line-bot': item.direction_Y == -1,
              }"
              :style="`width: ${item.s_w}px;`"
            >
              <div class="task-line-x-start-show task-line-shadow"></div>

              <div
                class="task-line-y-total"
                :class="{
                  'task-line-y-total-left': item.s_type == 'pre',
                  'task-line-y-total-right': item.s_type == 'next',
                  'task-line-top': item.direction_Y == 1,
                  'task-line-bot': item.direction_Y == -1,
                }"
                :style="`height: ${item.t_h}px;`"
              >
                <div class="task-line-y-total-show task-line-shadow"></div>
              </div>
            </div>

            <div
              class="task-line-x-end"
              :class="{
                'task-line-x-end-left': item.e_type == 'pre',
                'task-line-x-end-right': item.e_type == 'next',
                'task-line-top': item.direction_Y == -1,
                'task-line-bot': item.direction_Y == 1,
              }"
              :style="`width: ${item.e_w}px;`"
            >
              <div class="task-line-x-end-show task-line-shadow"></div>
              <div class="task-line-arrow"></div>

            </div>
          </template>

          <!-- 已字型 -->
          <template v-else-if="item.s_type != item.e_type && item.type == 3">
            <div
              class="task-line-j-start"
              :class="{
                'task-line-j-left': item.s_type == 'pre',
                'task-line-j-right': item.s_type == 'next',
                'task-line-top': item.direction_Y == 1,
                'task-line-bot': item.direction_Y == -1,
              }"
              :style="`width: ${item.s_w}px;`"
            >
              <div class="task-line-j-start-show task-line-shadow"></div>

              <div
                class="task-line-j-vertical"
                :class="{
                  'task-line-left': item.s_type == 'pre',
                  'task-line-right': item.s_type == 'next',
                  'task-line-top': item.direction_Y == 1,
                  'task-line-bot': item.direction_Y == -1,
                }"
                :style="{
                  'height': zStartHeight + 'px'
                }"
              >
                <div class="task-line-j-vertical-show task-line-shadow"></div>
              </div>
            </div>
            <div
              class="task-line-j-mid"
              :class="{
                'task-line-j-mid-top': item.direction_Y == -1,
                'task-line-j-mid-bot': item.direction_Y == 1,
              }"
            >
              <div class="task-line-j-mid-show task-line-shadow"></div>
            </div>
            <div
              class="task-line-j-end"
              :class="{
                'task-line-j-end-left': item.e_type == 'pre',
                'task-line-j-end-right': item.e_type == 'next',
                'task-line-top': item.direction_Y == -1,
                'task-line-bot': item.direction_Y == 1,
              }"
              :style="`width: ${item.e_w}px;`"
            >
              <div class="task-line-j-end-show task-line-shadow"></div>
              <div class="task-line-arrow"></div>
              <div
                class="task-line-j-vertical"
                :class="{
                  'task-line-top': item.direction_Y == -1,
                  'task-line-bot': item.direction_Y == 1,
                }"
                :style="`height: ${item.t_h - zStartHeight }px;`"
              >
                <div class="task-line-j-vertical-show task-line-shadow"></div>
              </div>
            </div>
          </template>

          <!-- 一字型 -->
          <template v-else-if="item.type == 4">
            <div
              class="task-line-1-xline"
              :style="`width: ${item.t_w}px;`"
            >
              <div class="task-line-1-xline-show"></div>
              <div class="task-line-arrow" v-show="item.t_w >= 6"></div>
            </div>


          </template>

        </div>
      </template>

    </div>
  </div>

</template>

<script>
export default {
  name: "GtLines",
  data() {
    return {
      actLine: -1, // 选中的线
    };
  },
  props: {
    barsCSSInfo: {
      type: Array,
      default: () => { return []; },
    },
    totalHeight: {
      type: Number,
      default: () => { return 0; },
    },
  },
  computed: {
    // 起点横道起始方向距所在行下（上）方高度（供己字型计算）
    zStartHeight() {
      const _sh = (this.$store.state.cellHeight + this.$store.state.taskHeight) / 2 + 1;
      return _sh;
    },
    // 换算连线关系数组
    getLinesArr: function() {
      const _self = this;
      const result = [];
      const taskPosInfoArr = this.barsCSSInfo;
      if (taskPosInfoArr && taskPosInfoArr.length > 0) {
        const _taskArr = _self.$utils.deepClone(taskPosInfoArr);
        // 起始分类
        for (let i = 0; i < _taskArr.length; i++) {
          const a = taskPosInfoArr[i]; // 任务起点坐标信息
          const _lineArr = _taskArr[i].taskLink;
          let _line;
          for (let n = 0; n < _lineArr.length; n++) {
            const _item = _lineArr[n];
            const endRowIndex = _self.$utils.fnGetIndex(_item.taskLinkId, taskPosInfoArr, "_id"); // 目标id的下标
            if (endRowIndex != -1) {
              const b2 = taskPosInfoArr[endRowIndex];
              if (a._width <= 0 || b2._width <= 0) {
                console.warn("连线关系: 横道宽度异常", a, b2);
                continue;
              }
              _line = _self.getLinesItemInfo(_item.startLinePosType, _item.endLinePosType, a, b2, i, endRowIndex);
              _line && result.push(_line);
            }
          }

        }
      }
      return result;
    },
    getHeight() {
      let ganttBgCss = "";
      if (this.totalHeight === 0) {
        ganttBgCss = "";
      } else {
        ganttBgCss = {
          "height": this.totalHeight + "px",
        };
      }
      return ganttBgCss;
    },
  },
  methods: {
    /**
     * @description: 换算单个连线关系
     * @param {_startType: 起点a方向左右}
     * @param {_endType: 终点b方向左右}
     * @param {posInfoA: 起点坐标}
     * @param {posInfoB: 终点坐标}
     * @param {sIndex: 起点索引}
     * @param {eIndex: 终点索引}
     * @return {
        s_x: 连线块起点x
        s_y: 连线块起点y
        s_w: 连线块起点宽度,
        s_type: 'pre'左起点 | 'next'右起点
        e_type: 'pre'左终点 | 'next'右终点
        e_w: 连线块终点宽度,
        direction_x: 1 朝右 | -1 朝左
        direction_Y: 1 朝下 | -1 朝上
        t_w: 连线块总宽
        t_h: 连线块总高
        type: 1: ]型 | 2: Z型(制造暂时废弃) | 3: 已字型 | 4: 一字型 | 5: 7+1字型
        s_index: 起点索引
        e_index: 终点索引
      }
    */

    getLinesItemInfo(_startType, _endType, posInfoA, posInfoB, sIndex, eIndex) {
      const _self = this;
      const b = posInfoB; // {_top: 7,_left: 360,_width: 80,_id: 2,...task}
      const a = posInfoA; // {_top: 42,_left: 200,_width: 80,_id: 1,...task}

      const _baseWidth = this.$store.getters.cellWidth / 2;
      const num = _baseWidth > 30 ? _baseWidth : 30; // 起点左右拓展基础值 30

      const _taskHeight = this.$store.state.taskHeight; // 20;
      const startType = _startType; // 'pre'
      const endType = _endType; // 'pre'
      // const ind = eIndex; // '被连接任务的位置信息的索引 || 任务信息索引'
      // console.log("连接关系:", a, b, sIndex, startType, "-->", ind, endType);

      let _sw; let _sx; let _sy; let _ew; let _dx; let _tw; let _th; let _type = 1;
      const startRightPoint = (a._left + a._width); // 左端点
      const endRightPoint = (b._left + b._width);// 右端点
      let _topItem, _botItem; // 靠上横道对象 靠下横道对象
      /* 新增·一字型 */
      if (
        a._top > 0 &&
        b._top > 0 &&
        (a.groupId == b.groupId && a.curRow === b.curRow)
      ) {
        // console.log("类型：一字型");

        const _aHeight = a.crossObjName == "task" && a.crossHeightVal > 0 ? a.crossHeightVal : _taskHeight;
        const _bHeight = b.crossObjName == "task" && b.crossHeightVal > 0 ? b.crossHeightVal : _taskHeight;
        // _sy = a._top - _aHeight / 2 + _taskHeight / 2;
        _sy = a._top + _aHeight / 2 - _taskHeight / 2;
        _type = 4;
        let _startPoint;
        let _endPoint;
        if (startType == "next") {
          _startPoint = startRightPoint;
          if (endType == "next") {
            _endPoint = endRightPoint;
          } else {
            _endPoint = b._left;
          }
        } else {
          _startPoint = a._left;
          if (endType == "next") {
            _endPoint = endRightPoint;
          } else {
            _endPoint = b._left;
          }
        }
        const baseWidth = _endPoint - _startPoint; // 三角变换前的宽
        const baseHeight = (b._top + _bHeight / 2) - (a._top + _aHeight / 2); // 三角变换前的高
        // console.log(_bHeight, _aHeight, baseHeight);
        let _deg; // 角度
        const getDeg = _self.$utils.getDeg;
        if (baseWidth > 0) {
          if (baseHeight > 0) {
            _deg = -1 * getDeg(baseWidth, baseHeight);
          } else if (baseHeight == 0) {
            _deg = -90;
          } else {
            _deg = -(180 - getDeg(baseWidth, baseHeight));
          }
        } else if (baseWidth == 0) {
          if (baseHeight > 0) {
            _deg = 0;
          } else if (baseHeight == 0) {
            _deg = 0;
          } else {
            _deg = -180;
          }
        } else {
          if (baseHeight > 0) {
            _deg = getDeg(baseWidth, baseHeight);
          } else if (baseHeight == 0) {
            _deg = 90;
          } else {
            _deg = 180 - getDeg(baseWidth, baseHeight);
          }
        }
        _deg += 90;

        _dx = (_startPoint >= _endPoint ? -1 : 1);
        _tw = Math.sqrt(Math.pow(baseWidth, 2) + Math.pow(baseHeight, 2));
        const demo = {
          s_x: _startPoint, // 连线块起点x
          s_y: _sy, // 连线块起点y
          s_w: baseHeight, // ***一字型用来做判断是否需要旋转变换 0 不需要变换***
          e_w: _deg, // ***一字型用来记录 旋转角度***
          s_type: startType, // 'pre'左起点,'next'右起点
          e_type: endType, // 'pre'左终点,'next'右终点
          direction_x: _dx, // 1 朝右 -1 朝左
          direction_Y: (_aHeight > _bHeight ? 1 : -1), // 1 朝下 -1 朝上
          t_w: _tw, // 连线块总宽
          t_h: _taskHeight, // 连线块总高
          type: _type, // [1:【】型,2: Z型,3: 已字型,4: 一字型,]
          s_index: sIndex, // 起点索引
          e_index: eIndex, // 终点索引
        };
        return demo;
      } else if (a._top < b._top) {
        _topItem = a;
        _botItem = b;
      } else {
        _topItem = b;
        _botItem = a;
      }
      const _topHeight = _topItem.crossObjName == "task" && _topItem.crossHeightVal > 0 ? _topItem.crossHeightVal : _taskHeight;
      const _botHeight = _botItem.crossObjName == "task" && _topItem.crossHeightVal > 0 ? _botItem.crossHeightVal : _taskHeight;
      const _topMid = _topItem._top + _topHeight / 2;
      const _botMid = _botItem._top + _botHeight / 2;

      const isType7 = true; // 使用7型连线
      // 普通横道: 加上横道本身高度与标准高度20高度差一半的向下偏移
      const _offsetTop = (_topHeight - _taskHeight) / 2 || 0;
      _th = Math.abs(_topMid - _botMid) + _taskHeight;

      const _borderRadiusWidth = this.$store.state.viewSchem.noTaskBorderRadiusShow ? 0 : 2; // 圆角额外偏移
      const _diffX = b.crossObjName === "landmarks" ? (_taskHeight / 2) : _borderRadiusWidth; // 横向偏移2处理圆角空缺,里程碑10
      if (startType == "next") {
        if (endType == "next") {
          // console.log("类型：]·");
          _sw = ((startRightPoint >= endRightPoint) ? num : Math.abs(startRightPoint - endRightPoint) + num);
          _sx = ((startRightPoint >= endRightPoint) ? endRightPoint : startRightPoint);
          _sy = _topItem._top;
          _dx = (startRightPoint >= endRightPoint ? -1 : 1);
          _tw = Math.abs(startRightPoint - endRightPoint) + num;
          _ew = ((startRightPoint >= endRightPoint) ? _tw : num);
          _type = 1;
        } else {
          const _diff = Math.abs(b._left - startRightPoint);
          if (
            isType7 &&
            startRightPoint <= b._left + 1
          ) {
            // console.log("类型：右7+1字型");
            _sw = 0;
            _sx = startRightPoint;
            _dx = startRightPoint <= b._left ? 1 : -1;
            _tw = _diff + 4 + _diffX;// 箭头占位4, 横向偏移2处理圆角空缺
            _ew = 0;
            _type = 5;

            /* 容器 */
            if (a._top < b._top) {
              _sy = _topItem._top;
              _th = Math.abs(b._top - (_topMid - _taskHeight / 2));
            } else {
              _sy = (_topItem._top + _topHeight) - _offsetTop;
              _th = Math.abs((_botMid + _taskHeight / 2) - (b._top + _topHeight));
            }

          } else if (
            startRightPoint <= b._left &&
            _diff <= num * 2
          ) {
            // console.log("类型：右特殊已·");
            _sw = _diff + num;
            _sx = startRightPoint - num;
            _sy = _topItem._top;
            _dx = startRightPoint <= b._left ? 1 : -1;
            _tw = _diff + (num * 2);
            _ew = _diff + num;
            _type = 3;
          } else {
            // console.log("类型：右Z | 已·");
            _sw = num;
            _sx = (startRightPoint > b._left ? b._left - num : startRightPoint);
            _sy = _topItem._top;
            _dx = startRightPoint <= b._left ? 1 : -1;
            _tw = startRightPoint >= b._left ? (startRightPoint - b._left + (num * 2)) : _diff;
            _ew = startRightPoint >= b._left ? _tw - num - (startRightPoint - b._left) : _tw - num + (_taskHeight / 2 + 1);
            _type = startRightPoint >= b._left ? 3 : 2;
          }

        }

      } else {
        const _diff = Math.abs(a._left - endRightPoint);
        if (endType == "next") {
          if (
            isType7 &&
            endRightPoint <= a._left + 1
          ) {
            // console.log("类型：左7+1字型");
            _sw = 0;
            _sx = endRightPoint - 4 - _diffX; // 横向偏移2处理圆角空缺
            _dx = startRightPoint <= b._left ? 1 : -1;
            _tw = _diff + 4 + _diffX;// 箭头占位4, 横向偏移2处理圆角空缺
            _ew = 0;
            _type = 5;

            /* 容器 */
            if (a._top < b._top) {
              _sy = _topItem._top;
              _th = Math.abs(b._top - (_topMid - _taskHeight / 2));
            } else {
              _sy = (_topItem._top + _topHeight) - _offsetTop;
              _th = Math.abs((_botMid + _taskHeight / 2) - (b._top + _topHeight));
            }

          } else if (
            endRightPoint <= a._left &&
            a._left - endRightPoint <= num * 2
          ) {
            // console.log("类型：左特殊已·");
            _sw = _diff + num;
            _sx = endRightPoint - num;
            _sy = _topItem._top;
            _dx = a._left <= endRightPoint ? 1 : -1;
            _tw = _diff + (num * 2);
            _ew = _diff + num;
            _type = 3;
          } else {
            // console.log("类型：左Z | 已·"); // 左反Z【业务场景基本不存在】
            _sw = num;
            _sx = a._left <= endRightPoint ? a._left - num : endRightPoint;
            _sy = _topItem._top;
            _dx = endRightPoint >= a._left ? 1 : -1;
            _tw = a._left <= endRightPoint ? _diff + num * 2 : _diff;
            _ew = a._left <= endRightPoint ? num : _diff - num + (_taskHeight / 2 + 1);
            _type = a._left <= endRightPoint ? 3 : 2;

          }
        } else {
          // console.log("类型：[");
          _sw = a._left <= b._left ? num : Math.abs(a._left - b._left) + num;
          _sx = a._left <= b._left ? a._left - num : b._left - num;
          _sy = _topItem._top;
          _dx = b._left >= a._left ? 1 : -1;
          _tw = Math.abs(a._left - b._left) + num;
          _ew = a._left <= b._left ? _tw : num;
          _type = 1;
        }

      }
      const demo = {
        s_x: _sx, // 连线块起点x
        s_y: _sy + _offsetTop, // 连线块起点y
        s_w: _sw,
        s_type: startType, // 'pre'左起点,'next'右起点
        e_type: endType, // 'pre'左终点,'next'右终点
        e_w: _ew,
        direction_x: _dx, // 1 朝右 -1 朝左
        direction_Y: (a._top > b._top ? -1 : 1), // 1 朝下 -1 朝上
        t_w: _tw, // 连线块总宽
        t_h: _th, // 连线块总高
        type: _type, // [1:【】型,2: Z型,3: 已字型]
        s_index: sIndex, // 起点索引
        e_index: eIndex, // 终点索引
      };
      return demo;
    },

    HandleOver(index) {
      this.actLine = index;
    },
    HandleOut() {
      this.actLine = -1;
    },

  },
};
</script>

<style scoped lang='less'>
@import './GtLines.less';

</style>
